let domain = 'https://up.qbox.me';
const tokenUrl = 'http://chuanyinet.madridwine.cn/api/image/qnUpload';
const qiNiuHost = 'https://img.jj58.com.cn/';
function getToken(){
    return new Promise((resolve,reject)=>{
        let xhr = window.XMLHttpRequest
            ? new XMLHttpRequest()
            : ActiveXObject("microsoft.XMLHttp");
        xhr.open("GET", tokenUrl, true);
        /*上传进度监听事件的添加*/
        // xhr.upload.addEventListener('progress', function (e) {
        //     item.uploadPercentage = Math.round((e.loaded * 100) / e.total);
        // }, false);
        xhr.send();
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
                //步骤五 如果能够进到这个判断 说明 数据 完美的回来了,并且请求的页面是存在的
               resolve(JSON.parse(xhr.responseText))
            }
        };
    })
}
function up(file,token) {
    return new Promise((resolve,reject)=>{
        let formfile = new FormData();
        formfile.append("file", file);
        formfile.append("name", file.name);
        formfile.append("token", token);
        let xhr = window.XMLHttpRequest
            ? new XMLHttpRequest()
            : ActiveXObject("microsoft.XMLHttp");
        xhr.open("POST", domain, true);
        /*上传进度监听事件的添加*/
        // xhr.upload.addEventListener('progress', function (e) {
        //     item.uploadPercentage = Math.round((e.loaded * 100) / e.total);
        // }, false);
        xhr.send(formfile);
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
                //步骤五 如果能够进到这个判断 说明 数据 完美的回来了,并且请求的页面是存在的
               resolve(JSON.parse(xhr.responseText))
            }
        };
    })
}
export {
    getToken,
    up,
    qiNiuHost,
}